import { Api as apiService } from '../api';
export class BulkUploadApiService {
    static uploadFile(uploadType, data, fileType, accountId, bucketId) {
        let endpointUrl;
        if (uploadType === 'team') {
            endpointUrl = '/api/team_bulk_upload/upload_csv';
        }
        else if (uploadType === 'categories') {
            endpointUrl = '/api/categories/upload_csv';
        }
        else if (uploadType === 'card_statement') {
            // exit early if the user has uploaded an unsupported file
            if (fileType !== 'csv' && fileType !== 'ofx') {
                // eslint-disable-next-line no-restricted-globals
                return Promise.resolve({
                    valid: false,
                    diffs: [],
                    message: 'File must be a valid .csv or .ofx file.'
                });
            }
            endpointUrl = `api/web/accounts/${accountId}/card_statement_upload/diff/${fileType}`;
        }
        else if (uploadType === 'expense_tags') {
            endpointUrl = `/api/expense_tags/${bucketId}/upload_csv`;
        }
        fileType = fileType.toLowerCase();
        const fileData = { [fileType]: data };
        return apiService.post(endpointUrl, fileData).then((response) => response.json());
    }
    static applyBulkUploadDiffs(uploadType, diffs, savedCsv, changesToApply, bucketId) {
        let endpointUrl;
        if (uploadType === 'team') {
            endpointUrl = '/api/team_bulk_upload/apply_diffs';
        }
        else if (uploadType === 'categories') {
            endpointUrl = '/api/categories/apply_diffs';
        }
        else if (uploadType === 'expense_tags') {
            endpointUrl = `/api/expense_tags/${bucketId}/apply_diffs`;
        }
        return apiService.put(endpointUrl, { diffs, changesToApply, savedCsv }).then((response) => response.json());
    }
    static applyCardStatementDiffs(diffs, savedFile, fileType, accountId) {
        // we dont need to use changesToApply on the backend right now
        const changesToApply = {};
        const endpointUrl = `api/web/accounts/${accountId}/card_statement_upload/apply/${fileType}`;
        return apiService.post(endpointUrl, { diffs, changesToApply, savedFile }).then((response) => response.json());
    }
}
